import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import LecturesContent from '../../components/Pages/Notifications';

const { displayName } = config;

export default function Lectures(): React.ReactNode | null {
  document.title = `${displayName}: Уведомления`;

  return (
    <Layout>
      <LecturesContent />
    </Layout>
  );
}
